// extracted by mini-css-extract-plugin
export default {"AutoSizeCard":"autoSizeCard_AutoSizeCard__dhQiV","ContentWrapper":"autoSizeCard_ContentWrapper__w0Q6i"};